import { Card, CardContent, Typography, Box } from '@mui/material'
import { VISIT_COLORS } from '../../constants/ClientDashboardConst'

export default function VisitMetricCard({
  title,
  value,
  subtitle,
  subtitle2,
  icon,
  iconBg = '#E9EFF6',
  iconColor = VISIT_COLORS.primary
}) {
  return (
    <Card elevation={4} sx={{ borderRadius: 2, height: 250, width: 165, border: '3px solid #E4E4E4', boxShadow: 0 }}>
      <CardContent align="center">
        <Typography sx={{ fontSize: 36, fontWeight: 900 }}>{value}</Typography>
        <Typography sx={{ fontWeight: 600, color: VISIT_COLORS.textSecondary }}>
          {title}
        </Typography>
        <Typography sx={{ color: VISIT_COLORS.muted }}>{subtitle}</Typography>
        <Typography sx={{ color: VISIT_COLORS.muted }}>{subtitle2}</Typography>

        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: '50%',
            backgroundColor: iconBg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: iconColor,
            mt: 0.5
          }}
        >
          {icon}
        </Box>
      </CardContent>
    </Card>
  )
}
